import { advanceExpensesRoutes } from "./advance";
import { vendorPaymentsRoutes } from "./vendor-payment";

export const expenseModuleRoutes =
  advanceExpensesRoutes.concat(vendorPaymentsRoutes);
